/* eslint-disable react/jsx-props-no-spreading */
import React, { useState } from 'react';
import { CheckboxList } from '@ui/molecules/inputs';
import { translate } from '@utils/i18n';
function CheckboxListWrapper({ options, objectName, namespace }) {
    const initialChecked = options.filter((opt) => opt.checked).map((opt) => opt.name);
    const [checkedValues, setCheckedValues] = useState(initialChecked);
    const handleChange = (changedId) => {
        setCheckedValues((prev) => {
            if (prev.includes(changedId)) {
                return prev.filter((id) => id !== changedId);
            }
            return [...prev, changedId];
        });
    };
    const transformedOptions = options.map((opt) => ({
        title: translate(opt.name, { namespace }),
        value: opt.name,
        description: translate(`${opt.name}_description`, { namespace, defaultValue: '' })
    }));
    return (React.createElement(React.Fragment, null,
        options.map((opt) => (React.createElement("input", { key: opt.name, type: "hidden", id: `${objectName}_${opt.name}`, name: `${objectName}[${opt.name}]`, value: checkedValues.includes(opt.name) ? '1' : '0' }))),
        React.createElement(CheckboxList, { options: transformedOptions, onChange: handleChange, label: "", value: checkedValues })));
}
export default CheckboxListWrapper;
